import React from "react"

const PleaseWait = ({ response }) => {
    console.log(response)

    return <div>PleaseWait</div>
}

export default PleaseWait
